import { defineStore } from "pinia"
import { externalLinks } from '@/utils/external_links'
import { useApiStore, apiIdOf, API_ORIGIN, axiosRetryx } from "@/stores/api"
import { apiDefaultDescriptions, type ApiOptions } from "@/stores/api"

export const useSupportStore = defineStore('support', () => {
  const { apiCall, checkResponseError } = useApiStore()

  // サポートURL取得API
  const getSupportUrl = async (
    args: { 
      url_type?: 'contact' | 'premiumStore' | 'updateHistory'
      __apiOptions?: ApiOptions
    }
  ) => {
    const url = await(async()=>{
      const apiOptions = args.__apiOptions || {}
      apiOptions.apiId = apiIdOf('getSupportUrl');

      return await apiCall<string>(apiOptions, async (apiConfig) => {
        const url = API_ORIGIN + "/getsupporturl";
        const data = {
          url_type: args.url_type,
        }

        const response = await axiosRetryx({ method: 'post', url, data, ...apiConfig })

        const descriptions = {
          ...apiDefaultDescriptions,
        }

        if (checkResponseError(response, descriptions, apiOptions)) {
          return;
        }
        return response.data.url;
      })
    })()
    if (!args.url_type || args.url_type == 'contact') {
      if (!url) return externalLinks.contact_support_support.url
    }
    return url;
  }

  return {
    getSupportUrl,
  }
})